var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "page",
    [
      _c("div", { staticClass: "page-title" }, [_vm._v("投放管理")]),
      _c(
        "div",
        { staticClass: "page-content" },
        [
          _c(
            "div",
            { staticClass: "toolbar" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.openCreate },
                },
                [_vm._v("新增渠道")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: { data: _vm.list, border: "", stripe: "", size: "small" },
            },
            [
              _c("el-table-column", {
                attrs: {
                  resizable: false,
                  type: "index",
                  label: "#",
                  width: "50",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  resizable: false,
                  prop: "channel_no",
                  label: "渠道编号",
                  "min-width": "120",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  resizable: false,
                  prop: "channel_name",
                  label: "渠道名称",
                  "min-width": "140",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  resizable: false,
                  prop: "channel_type",
                  label: "广告渠道",
                  width: "120",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              size: "mini",
                              type:
                                scope.row.channel_type === "META_PIXEL"
                                  ? "warning"
                                  : "info",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.channelTypeLabel(scope.row.channel_type)
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  resizable: false,
                  label: "落地页 URL",
                  "min-width": "200",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " + _vm._s(_vm.displayLandingUrl(scope.row)) + " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  resizable: false,
                  prop: "created_at",
                  label: "创建时间",
                  width: "168",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(_vm._s(_vm.formatTs(scope.row.created_at))),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  resizable: false,
                  label: "操作",
                  width: "180",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.openEdit(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _c(
                          "el-popconfirm",
                          {
                            attrs: { title: "确定删除该渠道？" },
                            on: {
                              confirm: function ($event) {
                                return _vm.handleDelete(scope.row)
                              },
                            },
                          },
                          [
                            _c(
                              "el-button",
                              {
                                staticStyle: { color: "#f56c6c" },
                                attrs: {
                                  slot: "reference",
                                  type: "text",
                                  size: "small",
                                },
                                slot: "reference",
                              },
                              [_vm._v("删除")]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-wrap" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.page,
                  "page-size": _vm.pageSize,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.total,
                  "page-sizes": [10, 20, 30, 50],
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handlePageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.dialogVisible,
            width: "560px",
            "destroy-on-close": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            closed: _vm.resetForm,
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.detailLoading,
                  expression: "detailLoading",
                },
              ],
              ref: "formRef",
              attrs: {
                model: _vm.form,
                rules: _vm.formRules,
                "label-width": "108px",
                size: "small",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "渠道编号", prop: "channel_no" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder:
                        "唯一编号，仅支持字母、数字、下划线，如 meta_01",
                      disabled: _vm.isEdit,
                      clearable: "",
                    },
                    model: {
                      value: _vm.form.channel_no,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "channel_no", $$v)
                      },
                      expression: "form.channel_no",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "渠道名称", prop: "channel_name" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "展示名称", clearable: "" },
                    model: {
                      value: _vm.form.channel_name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "channel_name", $$v)
                      },
                      expression: "form.channel_name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "广告渠道", prop: "channel_type" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "请选择" },
                      on: { change: _vm.onChannelTypeChange },
                      model: {
                        value: _vm.form.channel_type,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "channel_type", $$v)
                        },
                        expression: "form.channel_type",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "META_PIXEL", value: "META_PIXEL" },
                      }),
                      _c("el-option", {
                        attrs: { label: "LINK", value: "LINK" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "落地页 URL", prop: "url" } },
                  [
                    _c(
                      "div",
                      [
                        _vm._v(" " + _vm._s(_vm.form.url) + " "),
                        _c("el-button", {
                          staticClass: "copy-btn",
                          attrs: {
                            type: "text",
                            icon: "el-icon-copy-document",
                            border: "none",
                            size: "mini",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.copyText(_vm.form.url)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
              ],
              _vm.form.channel_type === "META_PIXEL"
                ? [
                    _c(
                      "el-form-item",
                      { attrs: { label: "Pixel ID", prop: "pixel_id" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "pixel_id", clearable: "" },
                          model: {
                            value: _vm.form.pixel_id,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "pixel_id", $$v)
                            },
                            expression: "form.pixel_id",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: "Access Token", prop: "access_token" },
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            rows: 3,
                            placeholder: "access_token",
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.access_token,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "access_token", $$v)
                            },
                            expression: "form.access_token",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "Meta 配置" } },
                      [
                        _c("el-input", {
                          staticClass: "meta-config-json",
                          attrs: {
                            value: _vm.metaConfigJsonPreview,
                            type: "textarea",
                            rows: 6,
                            readonly: "",
                            placeholder: "提交时将序列化为 channel_config",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    loading: _vm.submitting,
                  },
                  on: { click: _vm.submitForm },
                },
                [_vm._v(_vm._s(_vm.submitButtonText))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }